import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=4681d7fa&scoped=true&"
import script from "./stepFour.vue?vue&type=script&lang=js&"
export * from "./stepFour.vue?vue&type=script&lang=js&"
import style0 from "./stepFour.vue?vue&type=style&index=0&lang=less&"
import style1 from "./stepFour.vue?vue&type=style&index=1&id=4681d7fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681d7fa",
  null
  
)

export default component.exports